module.exports = __webpack_public_path__ + "media/images/icons/check-circle-a8b84bb717522a5fb055ff48491f3d9a.svg";